__turbopack_context__.v({
  "className": "yellowtail_fc684fc6-module__1nD8yG__className",
});
